// components/Layout.js
import React from 'react';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Sidebar />
      <Box sx={{ flex: 1 }}>  {/* no marginLeft, padding handled by CSS */}
        {children}
      </Box>
    </Box>
  );
};

export default Layout;